import { trigger, state, style, animate, transition } from '@angular/animations';

export const chatHeadAnimation = trigger('chatHeadAnimation', [
  state('initial', style({ right: '20px' })),
  state('moved', style({ right: '100px' })),
  transition('initial <=> moved', animate('2000ms ease-in-out'))
]);

export const teamInfoAnimation = trigger('teamInfoAnimation', [
  transition(':enter', [
    style({ left: '0', opacity: 0 }),
    animate('2s ease-in', style({ left: '70px', opacity: 1 })),
    animate('3s') 
  ]),
  transition(':leave', [
    animate('2s ease-in', style({ left: '0', opacity: 0 }))
  ])
]);


export const bannerTextAnimation = trigger('bannerTextAnimation', [
    transition(':enter', [
      style({ left: '0', opacity: 0 }),
      animate('3s ease-in', style({ opacity: 1 })),
    ]),
    transition(':leave', [
      animate('2s ease-in', style({ opacity: 0 })),
      animate('3s')
    ])
]);

export const chatHeadMoveAnimation = trigger('chatHeadMoveAnimation', [
  state('default', style({
    left: '0px'
  })),
  state('moved', style({
    left: '180px'
  })),
  transition('default <=> moved', [
    animate('1s ease-in-out')
  ])
]);

export const toggleOptions = trigger('toggleOptions', [
  state('collapsed', style({
    width: '0',
    opacity: 0,
  }), { params: { leftPosition: '0px' } }),
  state('expanded', style({
    width: '180px',
    opacity: 1,
  })),
  state('expanded-280', style({
    width: '280px',
    opacity: 1,
  })),
  transition('collapsed <=> expanded', [
    animate('1s ease-in-out')
  ]),
  transition('collapsed <=> expanded-280', [
    animate('1s ease-in-out')
  ])
  
]);